<div class="chat-window">
  @if (connected()) {
    <div class="messages" #messagesContainer>
      @for (message of messages(); track message.timestamp) {
        @if (message.sender) {
          <app-paper-chat-sending-bubble [message]="message"></app-paper-chat-sending-bubble>
        } @else {
          <app-paper-chat-receiving-bubble
            [papers]="papers()"
            [isSmallScreen]="isSmallScreen()"
            [message]="message"></app-paper-chat-receiving-bubble>
        }
      }
    </div>
    @if (projectId()) {
      <app-paper-chat-send [projectId]="projectId()"></app-paper-chat-send>
    }
  } @else {
    <p>Not connected</p>
  }
</div>
